import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Box, Stack, Typography } from "@mui/material";
import { humanizeKey } from "../../../../../Helper/DigitalTwin/DigitalTwinFunctions";

const buildSeries = (title, segments, colors) => {
  // Build ApexChart series
  return segments.map((seg, i) => ({
    name: `${seg.status}-${i}`,
    data: [seg.value],
    timestamp: seg.timestamp,
    title: title,
    customLabel: seg.status, // used in tooltip
    color: colors[seg.status],
  }));
}

const buildOptions = (id) => {
  return {
    chart: {
      id: id,
      type: 'bar',
      stacked: true,
      toolbar: { show: false },
      animations: { enabled: false },
      sparkline: { enabled: true }, // Removes extra chart padding
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '100%', // ensures it fills available height
        distributed: false,
      },
    },
    xaxis: {
      min: 0,
      max: 288, // 5-minute interval total is 288 - rounding off to nearest multiple of 10
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      categories: [''],
      show: false,
    },
    grid: {
      show: false,
      padding: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        // Safety checks
        const originalStatus = w?.globals?.initialSeries?.[seriesIndex]?.customLabel ?? '';
        const title = w?.globals?.initialSeries?.[seriesIndex]?.title ?? '';
        const timestamp = w?.globals?.initialSeries?.[seriesIndex]?.timestamp ?? '';
        const color = w?.globals?.colors?.[seriesIndex] ?? '#999';

        return `
          <div style="
            border-radius: 6px;
            background: white;
            box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
          ">
            <div style="display: flex; align-items: center; gap: 6px;padding: 8px 12px;background-color: #ECEFF1">
              <span style="font-weight: 600; font-size: 12px; line-height: 16px;">${timestamp}</span>
            </div>
            <div style="display: flex; align-items: center; gap: 6px;padding: 8px 12px;">
              <span style="
                width: 10px;
                height: 10px;
                background: ${color};
                border-radius: 50%;
                display: inline-block;
              "></span>
              <span style="font-weight: 400; font-size: 12px; line-height: 16px; color: #494949;">${title}:</span>
              <span style="font-weight: 500; font-size: 12px; line-height: 16px; margin-left: auto; text-transform: capitalize; color: #494949;">${originalStatus}</span>
            </div>
          </div>
        `;
      }
    },
    legend: { show: false },
  };
}

const BinarySignalStatusBarChart = ({ chartId, title, segments, colors }) => {

  const series = buildSeries(title, segments, colors);
  const options = buildOptions(chartId);

  return (
    (
      <Box sx={{ width: "100%", px: 10, mx: "auto" }}>
        <Box sx={{ mb: 1.5 }}>
          <Typography variant="fw500s12c686868" sx={{ lineHeight: '16px' }}>{title}</Typography>
        </Box>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" mb={1}>
          {Object.entries(colors).map(([key, color]) => (
            <Stack direction="row" alignItems="center" spacing={0.5} key={key}>
              <Box sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: color,
              }} />
              <Typography variant="fw400s12c3D4B5A" sx={{ lineHeight: '16px' }}>
                {humanizeKey(key)}
              </Typography>
            </Stack>
          ))}
        </Stack>
        <Chart
          key={Math.random()}
          id={chartId}
          options={options}
          series={series}
          type="bar"
          height="24px"
          width="100%"
        />
      </Box>
    )
  );
};

export default BinarySignalStatusBarChart;
